import Modal from 'components/Modal'
import BulkTransactions from '../BulkTransactionsTx'

const ModalBulkTransactions = ({
  title,
  open,
  onClose,
}: {
  title: string | undefined
  open: boolean
  onClose: () => void
}): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <BulkTransactions onClose={onClose} />
    </Modal>
  )
}

export default ModalBulkTransactions
